import React, {FC} from 'react';
import styled from 'styled-components';

import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';
import borderAndShadows from '../../assets/images/borderAndShadows.png';
import {VisitorViewerSidebarContentV3} from './visitorViewerSidebarContentV3';
import {VisitorViewerSidebarFooter} from './visitorViewerSidebarFooter';

/*
 * Style.
 */

const StyledSidebarDiv = styled.div`
  display: grid;
  grid-template-rows: auto auto 1fr auto;
  justify-items: center;
  align-items: center;
  height: 100%;
  width: 400px;
  min-width: 320;
  ${(p) => boxShadow(p.theme, `0 0 20px ${p.theme.alphas.gray20}`)};
  background-image: url(${borderAndShadows});
  background-size: cover;
  background-position: center bottom;
`;

/*
 * Component.
 */

export const VisitorViewerSidebarV3: FC = () => (
  <StyledSidebarDiv>
    <VisitorViewerSidebarContentV3 />
    {/* Empty div for grid-template-rows spacing */}
    <div />
    <VisitorViewerSidebarFooter />
  </StyledSidebarDiv>
);
